<template lang="pug">
l-control(
  :title="title"
  position="topright")
  button(
    :class="['ark-lf-control-container',\
    dense ? 'ark-control-dense' : 'ark-control-normal',\
    'text-center',\
    'pt-1']"
    @click="$emit('click')")
    v-icon(:size="dense ? 23 : 30" color="grey darken-1") {{ icon }}
</template>

<script>
import { LControl } from 'vue2-leaflet';

export default {
  name: 'LfControlAction',

  components: {
    LControl,
  },

  props: {
    // propiedad con el icono de material design
    icon: {
      type: String,
      required: true
    },
    // el titulo d ela ayuda del control
    title: {
      type: String,
      default: ''
    },
    // indica si se va a amostra un control denso
    dense: {
      type: Boolean,
      default: false
    },
    // posicion del control con los valores permitiod de leaflet
    position: {
      type: String,
      default: 'topright',
      validator(value) {
        return ['topright', 'topleft', 'bottomright', 'bottomleft'].includes(value);
      }
    }
  },

  methods: {
    clickHandler() {
      window.alert('and mischievous');
    }
  }
};
</script>

<style scoped>
.ark-lf-control-container {
  background-color: white;
  border: solid 2px rgba(0, 0, 0, 0.4);
}
.ark-control-normal {
  border-radius: 4px;
  height: 46px;
  width: 46px;
}
.ark-control-dense {
  border-radius: 3px;
  height: 30px;
  width: 30px;
}
</style>
